import { useNavigate } from "@tanstack/react-router";
import { AlertIcon } from "@signet/ui";
import { useSeenQuery } from "@signet/web-kit";
import { daysBetween, melbourneToday } from "../shared/dates.ts";
import { exKeys, fetchUpcoming, whenLabel } from "./api.ts";

/* ──────────────────────────────────────────────────────────────────────────
   The very top of Now, above the greeting (Jay, 2026-10-21): what runs out
   in the next few days, overdue ones included. Open goes to the page's "next
   week" box. Draws nothing when nothing is close.
   ────────────────────────────────────────────────────────────────────────── */

const SOON_DAYS = 3;

export function ExpiriesNowTop() {
  const navigate = useNavigate();
  const list = useSeenQuery({ queryKey: exKeys.upcoming(SOON_DAYS), queryFn: () => fetchUpcoming(SOON_DAYS), refetchInterval: 60_000 });
  const items = list.data?.items ?? [];
  if (!items.length) return null;
  const today = melbourneToday();

  return (
    <section className="ex-now" aria-label="Expiring soon">
      <span className="ex-now-icon"><AlertIcon size={15} /></span>
      <div className="ex-now-body">
        <strong>{items.length === 1 ? "1 thing expires" : `${items.length} things expire`} in the next few days</strong>
        <ul>
          {items.map((item) => {
            const days = daysBetween(today, item.nextExpiry!);
            return (
              <li key={item.id}>
                {item.name} <span className={days < 0 ? "ex-late" : undefined}>{whenLabel(days).toLowerCase()}</span>
              </li>
            );
          })}
        </ul>
      </div>
      <button type="button" className="button brass compact" onClick={() => void navigate({ to: "/expiries" as never, search: { focus: "upcoming" } as never })}>
        Open
      </button>
    </section>
  );
}
